import { useTranslation } from "react-i18next";
import RenewalHeader from "../RenewalHeader";
import { windowScroll } from "../../../../helpers/shared/useNavigationEffects";
import { useEffect } from "react";
import RenewalFooter from "../components/RenewalFooter";
import { Article } from "../../../../components/groups";

const HkSuccess = () => {
  const { t } = useTranslation("pages", { keyPrefix: "travel.payNow.HkPayment" });
  const { t: footer } = useTranslation("pages", { keyPrefix: "travel.payNow.hkFooter" });
  useEffect(() => {
    windowScroll();
  });
  return (
    <>
      <div className="flex flex-col min-h-screen gap-0">
        <RenewalHeader />
        <div className="container-flow flex-grow md:mt-16 my-8 md:mb-24">
          <div className="flex gap-10">
            <div className="w-full">
              <h2 className="font-serif font-bold text-3xl md:text-6xl mb-4">{t("success.title")}</h2>
              <Article>
                <p className="mb-0 mt-4">{t("success.content")}</p>
                <p className="mt-4 mb-4">
                  <div>{t("success.sub-title")}</div>
                  <div>{t("success.paragraph")}</div>
                </p>
                <p className="mt-4">{t("success.paragraph1")}</p>
              </Article>
              <Article>
                <p className="mt-8 mb-4 font-serif text-3xl md:text-6xl text-black">{t("success.paragraph2")}</p>
                <p className="mt-4 mb-4">
                  <div>{t("success.paragraph3")}</div>
                  <div>{t("success.paragraph4")}</div>
                </p>
                <p>
                  <div className="mt-4">{t("success.paragraph5")}</div>
                  <div className="mt-0">{t("success.paragraph6")}</div>
                </p>
                <p className="mt-4">{t("success.paragraph7")}</p>
              </Article>
            </div>
          </div>
        </div>
      </div>
      <RenewalFooter footer={footer} />
    </>
  );
};
export default HkSuccess;
